<div class="availability-edit-header">
  <h1 class="availability-edit-title">
    {{ ("availabilities" | i18n) || "Verfügbarkeiten" | titlecase }}
  </h1>
  <app-tab-toggle
    (click)="toggleView()"
    *ngIf="hasPoolerDepartmentAvailabilityOverview$ | async">
    <app-tab-toggle-option
      [active]="activeView === availabilityEditViewEnum.LIST"
      data-cy="availability-edit-toggle-list">
      <mat-icon
        svgIcon="list"
        class="toggle-icon"></mat-icon>
      {{ ("list" | i18n) || "Liste" }}
    </app-tab-toggle-option>
    <app-tab-toggle-option
      [active]="activeView === availabilityEditViewEnum.CALENDAR"
      data-cy="availability-edit-toggle-calendar">
      <mat-icon
        svgIcon="calendar-event"
        class="toggle-icon"></mat-icon>
      {{ ("calendar" | i18n) || "Kalender" }}
    </app-tab-toggle-option>
  </app-tab-toggle>
</div>
<ng-container *ngIf="activeView === availabilityEditViewEnum.LIST">
  <h2 *ngIf="isDispoEditingPooler && user">
    {{ formatUserName(user) }}
  </h2>
  <ng-container *ngIf="user">
    <mat-accordion>
      <app-availability-month-item
        *ngFor="
          let month of months;
          let i = index;
          trackBy: trackByStartDateString
        "
        [month]="month"
        [user]="user"
        [expanded]="i === 0">
      </app-availability-month-item>
    </mat-accordion>
  </ng-container>
</ng-container>
<ng-container *ngIf="activeView === availabilityEditViewEnum.CALENDAR">
  <app-user-availability-calendar
    *ngIf="user"
    [user]="user"
    [isDispoEditingPooler]="
      isDispoEditingPooler
    "></app-user-availability-calendar>
</ng-container>
<div
  class="a-fixed-action-bar a-fixed-action-bar--fixed-bottom"
  [class]="
    'view-' +
    (activeView === availabilityEditViewEnum.LIST ? 'list' : 'calendar')
  ">
  <button
    *ngIf="isDispoEditingPooler"
    class="mat-fab mat-fab--extended mat-fab-neutral mat-elevation-z8 d-none d-lg-inline-flex"
    (click)="historyBack()"
    type="button">
    <mat-icon svgIcon="arrow-left"></mat-icon>
    <span class="mat-fab__label">
      {{ ("back" | i18n) || "zurück" | uppercase }}</span
    >
  </button>
</div>
